import { z } from "zod";
import { dateOnlySchema, versionSchema } from "./common.js";

const wallTimeSchema = z
  .string()
  .regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Time must use HH:mm");

export const plannerAssignmentCreateSchema = z
  .object({
    projectId: z.string().uuid(),
    userId: z.string().uuid(),
    localDate: dateOnlySchema,
    startTime: wallTimeSchema,
    endTime: wallTimeSchema,
    notes: z.string().trim().max(1000).optional(),
    force: z.boolean().default(false),
  })
  .strict()
  .refine((value) => value.endTime > value.startTime, {
    path: ["endTime"],
    message: "End time must be after start time",
  });
export type PlannerAssignmentCreateDto = z.infer<
  typeof plannerAssignmentCreateSchema
>;

export const plannerAssignmentUpdateSchema = z
  .object({
    version: versionSchema,
    projectId: z.string().uuid().optional(),
    userId: z.string().uuid().optional(),
    localDate: dateOnlySchema.optional(),
    startTime: wallTimeSchema.optional(),
    endTime: wallTimeSchema.optional(),
    notes: z.string().trim().max(1000).nullable().optional(),
    force: z.boolean().default(false),
  })
  .strict();
export type PlannerAssignmentUpdateDto = z.infer<
  typeof plannerAssignmentUpdateSchema
>;

export const plannerAssignmentDeleteSchema = z
  .object({ version: versionSchema })
  .strict();
export type PlannerAssignmentDeleteDto = z.infer<
  typeof plannerAssignmentDeleteSchema
>;

export type PlannerConflictType =
  | "holiday"
  | "absence"
  | "overlapping_assignment"
  | "outside_work_schedule"
  | "over_capacity";
